export enum DynamicType {
  Titles = "Titles",
  CivilStatuses = "Civil Statuses",
  PersonTypes = "Person Types",
  LegalPersonTypes = "Legal Person Types",
  ShareholderTypes = "Shareholder Types",
  Sources = "Sources",
}
